export default (state = {}, action) => {
  switch (action.type) {
    case  'SET_PAGE_SETTINGS':
      return {...state, ...action.settings}
    case  'USET_PAGE_SETTINGS':
      return {}
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/settings.js